import { useEffect, useState } from 'react';
import { useWebAuth } from '../../../hooks/useWebAuth';
import { getOverviewStats, getSignupsPerWeek, getSharesPerDay } from '../../../api/admin-api';
import { StatCard } from '../components/StatCard';
import { SignupsChart } from './charts/SignupsChart';
import { SharesChart } from './charts/SharesChart';
import './OverviewPage.scss';

export function OverviewPage() {
  const { token } = useWebAuth();
  const [stats, setStats] = useState<any>(null);
  const [signups, setSignups] = useState<any[]>([]);
  const [shares, setShares] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    Promise.all([
      getOverviewStats(token),
      getSignupsPerWeek(token),
      getSharesPerDay(token),
    ])
      .then(([s, su, sh]) => {
        setStats(s);
        setSignups(su);
        setShares(sh);
      })
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="overview-page">Loading...</div>;
  if (!stats) return <div className="overview-page">Failed to load stats</div>;

  return (
    <div className="overview-page">
      <h1 className="overview-page__title">Overview</h1>

      <div className="overview-page__cards overview-page__cards--5">
        <StatCard label="Total Users" value={stats.totalUsers} />
        <StatCard label="Anonymous Users" value={stats.anonymousUsers} />
        <StatCard label="Active Users (30d)" value={stats.activeUsers30d} />
        <StatCard label="Paid Users" value={stats.paidUsers} />
        <StatCard label="MRR" value={`$${stats.mrr}`} />
      </div>

      <div className="overview-page__cards overview-page__cards--3">
        <StatCard label="Shares (30d)" value={stats.totalShares30d} />
        <StatCard label="Active Links" value={stats.activeLinks} />
        <StatCard label="Avg Shares / Active User" value={stats.avgSharesPerActiveUser} />
      </div>

      <div className="overview-page__charts">
        <div className="overview-page__chart">
          <h2 className="overview-page__chart-title">Signups per Week</h2>
          <SignupsChart data={signups} />
        </div>
        <div className="overview-page__chart">
          <h2 className="overview-page__chart-title">Shares per Day</h2>
          <SharesChart data={shares} />
        </div>
      </div>
    </div>
  );
}
